/*
 * @Author: 李才人
 * @Date: 2021-07-30 16:31:24
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-03 09:53:02
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\api\questionnaire.ts
 * @Description:
 */
// import { post, postExFile, getExFile } from "@utils/httpUtil";
import { post, postForm } from "@utils/httpUtil";
export const getQuestionnaireDetail = (data, config) => {
  return postForm(`/questionnaire/getDetailById`, data, config ? config : {
    originalData: false
  });
};
/**
 *
 * $ 保存问卷草稿
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveQuestionnaireDraft(data, config) {
  return post(`/questionnaire/saveDraft`, data, config);
}
/**
 *
 * 保存问卷
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveQuestionnaire(data, config) {
  return post(`/questionnaire/saveQuestionnaire`, data, config);
}
/**
 *
 * $ 根据社区id获取问卷草稿
 * @export
 * @param {{ communityId: string }} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<IQuestionData>}
 */
export function getQuestionnaireDraftByCommtyId(data, config) {
  return post(`/questionnaire/getDraft`, data);
}
export const getAllTask = config => {
  return post(`/community/user/task/getAllTask`, config ? config : {
    originalData: false
  });
};
export const saveCommunityTaskConfig = (data, config) => {
  return post(`/community/user/task/saveCommunityTaskConfig`, data, config ? config : {
    originalData: false
  });
};
export const checkQuestionnaireTitleUnique = (data, config) => {
  return post(`/questionnaire/checkQuestionnaireTitleUnique`, data, config ? config : {
    originalData: false
  });
};
/**
 * 查询分类列表
 * @param  data
 * @param RequestConfig
 * @returns
 */
export var EnumBusinessType;
(function (EnumBusinessType) {
  EnumBusinessType["QUESTIONNAIRE"] = "QUESTIONNAIRE";
  EnumBusinessType["ANSWER"] = "ANSWER";
})(EnumBusinessType || (EnumBusinessType = {}));
export var EnumCommunityType;
(function (EnumCommunityType) {
  EnumCommunityType["DOCTOR"] = "DOCTOR";
  EnumCommunityType["PATIENT"] = "PATIENT";
})(EnumCommunityType || (EnumCommunityType = {}));
export const getCatalog = (data, config) => {
  return post(`/baseQuestionnaire/getCatalog`, data, config ? config : {
    originalData: false
  });
};
/**
 * 分页查询题目
 * @param ICatalog
 * @param RequestConfig
 * @returns
 */
export const baseQuestionnaireGetPage = (data, config) => {
  return post(`/baseQuestionnaire/getPageRelation`, data, config ? config : {
    originalData: false
  });
};
/**
 * 获取随机题目
 * @param ICatalog
 * @param RequestConfig
 * @returns
 */
export const getRandomItems = (data, config) => {
  return post(`/baseQuestionnaire/getRandomItems`, data, config ? config : {
    originalData: false
  });
};
export const getCatalogSummary = (data, config) => {
  return post(`/baseQuestionnaire/catalog/getCatalogSummary`, data, config ? config : {
    originalData: false
  });
};
export const getAllIds = (data, config) => {
  return post(`/baseQuestionnaire/getAllIds`, data, config ? config : {
    originalData: false
  });
};
export function checkItemExist(data, config) {
  return post(`/questionnaire/checkItemExist`, data, config);
}
/**
 *
 * 保存问卷模板
 *
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function formtemplateSave(data, config) {
  return post(`/formtemplate/save`, data, config);
}
/**
 *
 * 保存问卷模板并且生成表单
 *
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveAndGenerateQuestionnaire(data, config) {
  return post(`/formtemplate/saveAndGenerateQuestionnaire`, data, config);
}
export const formtemplateGetDetail = (data, config) => {
  return post(`/formtemplate/getDetail`, data, config ? config : {
    originalData: false
  });
};
export const formtemplateGenerateQuestionnaire = (data, config) => {
  return post(`/formtemplate/generateQuestionnaire`, data, config ? config : {
    originalData: false
  });
};
export const formtemplateCheckTitleUnique = (data, config) => {
  return post(`/formtemplate/checkTitleUnique`, data, config ? config : {
    originalData: false
  });
};